import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader/index";
import CardContent from "@material-ui/core/CardContent/index";
import Grid from "@material-ui/core/Grid/index";
import React from "react";
import logo from '../../../assetImages/undraw_real-time_sync_o57k.svg';
import {NavLink} from "react-router-dom";

class GetStartedMobileAppDownloadWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Grid item xs={12} sm={6} md={4}>
                <Card className={appStyle.getStartedCard}>
                    <CardHeader
                        title='3. Connect'
                        subheader='.. and start using it'
                        titleTypographyProps={{align: 'center'}}
                        subheaderTypographyProps={{align: 'center'}}
                        action={null}
                        className={appStyle.getStartedCardHeader}
                    />
                    <CardContent>
                        <NavLink to="/explore">
                            <div className={appStyle.imgbox}>
                                <img className={appStyle.centerFit} src={logo}/>
                            </div>
                        </NavLink>
                    </CardContent>
                </Card>
            </Grid>
        );
    }
}

export default GetStartedMobileAppDownloadWidget;